import React, { PropsWithChildren, useContext, useEffect, useRef } from 'react'

import { Editor } from 'slate'
import { useSlate } from 'slate-react'

type TemplatedFormContextValue = {
  editors: Map<string, Editor>
}

const TemplatedFormContext = React.createContext<TemplatedFormContextValue | null>(null)

export const TemplatedForm = ({ children }: PropsWithChildren<any>) => {
  const ref = useRef<Map<string, Editor>>()

  if (!ref.current) {
    ref.current = new Map()
  }

  return (
    <TemplatedFormContext.Provider
      value={{
        editors: ref.current
      }}
    >
      {children}
    </TemplatedFormContext.Provider>
  )
}

export const TemplatedFormEditorReference = ({ name }: { name: string }) => {
  const editor = useSlate()
  const ctx = useTemplatedForm()

  useEffect(() => {
    if (ctx?.editors) {
      ctx.editors.set(name, editor)
    }
  }, [editor, name])

  return null
}

export const useTemplatedForm = () => {
  return useContext(TemplatedFormContext)
}
